// src/pages/RoutingStatusSandbox.jsx
import React from "react";
import RoutingStatus from "./RoutingStatus";

export default function RoutingStatusSandbox() {
  return <RoutingStatus sandbox />;
}

